import {
  useMemo,
  useState,
} from 'react'

export function AuthorizationPanel() {
  const [
    accepted,
    setAccepted,
  ] =
    useState(false)

  const [
    phrase,
    setPhrase,
  ] =
    useState('')

  const valid =
    useMemo(
      () =>
        accepted &&
        phrase
          .trim()
          .toUpperCase() ===
          'AUTORIZO',
      [
        accepted,
        phrase,
      ],
    )

  return (
    <section className="module-card">

      <header>
        <strong>
          Autorización
        </strong>

        <span>
          HUMAN_ONCE
        </span>
      </header>

      <p className="muted">
        Se mostrará cuando
        el CORE reporte
        AUTHORIZATION_PENDING.
      </p>

      <label className="checkbox-row">

        <input
          type="checkbox"
          checked={accepted}
          onChange={
            (event) =>
              setAccepted(
                event
                  .target
                  .checked,
              )
          }
        />

        He revisado el plan exacto.

      </label>

      <label className="authorization-field">

        <span>
          Escribe AUTORIZO
        </span>

        <input
          value={phrase}
          placeholder="AUTORIZO"
          onChange={
            (event) =>
              setPhrase(
                event
                  .target
                  .value,
              )
          }
        />

      </label>

      <button
        type="button"
        disabled={!valid}
        className="authorize"
      >
        AUTORIZAR / EJECUTAR
      </button>

    </section>
  )
}
